"use client";

import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Chauffeur() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = [{
    label: "RELIABILITY",
    value: "100%"
  }, {
    label: "FLEET",
    value: "PREMIUM"
  }, {
    label: "SERVICE",
    value: "EXECUTIVE"
  }];
  return <section data-section-id="3626" id="brandauthorityhero" className="bg-[#000000] text-[#E6E6E6] relative min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1722013/img/IMG_3111.png)]" />
      <div className="absolute inset-0" style={{
      background: "radial-gradient(ellipse at center, hsla(0, 0%, 0%, 0.4) 0%, hsla(0, 0%, 0%, 0.85) 70%, hsla(0, 0%, 0%, 0.95) 100%)"
    }} />
      <div className="absolute inset-0 bg-[#000000]/60" />

      {}
      <div className="absolute inset-0 mix-blend-overlay opacity-30" style={{
      background: "radial-gradient(circle at 30% 40%, hsla(0, 0%, 75%, 0.15) 0%, transparent 50%)"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-[#C0C0C0]/60" />

      {}
      <div className="relative z-10 mx-auto flex min-h-screen w-full max-w-[1600px] flex-col px-6 pt-24 pb-32 sm:px-10 lg:px-16">
        <div className="grid flex-1 grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-8">
          {}
          <div ref={headlineRef} className={`lg:col-span-9 flex flex-col justify-center transition-all duration-1000 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="mb-8 flex items-center gap-4">
              <span className="h-px w-12 bg-[#C0C0C0]" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#7A7A7A]">
                BEMAX — CHAUFFEURED SERVICE
              </span>
            </div>

            {}
            <h1 className="font-default font-bold uppercase leading-[0.85] tracking-tight text-[#FFFFFF]">
              <span className="block !text-6xl">ELEVATED</span>
              <span className="block !text-6xl sm:pl-[8vw] lg:pl-[120px]">
                TRANSIT
              </span>
            </h1>

            {}
            <div className="my-10 h-[2px] w-20 bg-[#C0C0C0]" />

            {}
            <p className="font-serif italic text-lg sm:text-xl text-[#E6E6E6] max-w-[520px] leading-relaxed">
              Delivering a seamless, sophisticated travel experience for those who demand nothing less than excellence.
            </p>

            {}
            <div className="mt-12 flex flex-col sm:flex-row gap-4 sm:items-center">
              <Button asChild size="lg" className="group h-14 px-8 bg-[#FFFFFF] text-[#000000] font-default font-bold uppercase tracking-wider text-sm shadow-lg hover:bg-[#C0C0C0] hover:shadow-[0_0_32px_hsla(0,0%,75%,0.7)] transition-all duration-300">
                <Link to="/SecureChauffeurPage">
                  Reserve Your Chauffeur
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Button asChild variant="link" className="font-mono text-xs uppercase tracking-[0.25em] text-[#E6E6E6] hover:text-[#C0C0C0] h-14 px-2">
                <Link to="/FleetPage">View Our Fleet →</Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={metaRef} className={`hidden lg:col-span-3 lg:flex items-stretch justify-end transition-all duration-1000 delay-300 ease-out ${metaVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative flex items-center">
              <div className="absolute right-0 top-0 bottom-0 w-px bg-[#C0C0C0]/60" />
              <div className="font-mono text-xs uppercase text-[#7A7A7A] tracking-[0.2em] whitespace-nowrap pr-6" style={{
              writingMode: "vertical-rl",
              transform: "rotate(180deg)"
            }}>
                BEMAX / EXECUTIVE TRANSPORT / PRIVATE TERMINAL / 24.7 SERVICE
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="relative z-10 mt-16 flex flex-col gap-8">
          {}
          <div className="flex items-center gap-3">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#7A7A7A]">
              Scroll
            </span>
            <ChevronDown className="size-4 text-[#C0C0C0] animate-bounce" />
          </div>

          {}
          <div className="h-px w-full bg-[#C0C0C0]/60" />

          {}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
            {dataPoints.map((point, i) => <div data-index={i} key={point.label} className="flex items-baseline gap-4">
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#7A7A7A]">
                  {point.label}
                </span>
                <span className="font-default font-bold text-lg text-[#FFFFFF]">
                  {point.value}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-[#C0C0C0]/60" />
    </section>;
}